import { render, staticRenderFns } from "./CurrentUrlModal.vue?vue&type=template&id=29b197dd&"
import script from "./CurrentUrlModal.vue?vue&type=script&lang=js&"
export * from "./CurrentUrlModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports